import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { customElement, queryAssignedElements } from 'lit/decorators.js';
import componentStyles from './outline-org-chart.css.lit';
import { OutlineOrgChartBaselinePanel } from './outline-org-chart-panel/outline-org-chart-panel';
/**
 * The OutlineOrgChart component
 * @element outline-org-chart
 */
@customElement('outline-org-chart')
export class OutlineOrgChart extends OutlineElement {
  'slots' = new SlotsController(this);
  static 'styles': CSSResultGroup = [componentStyles];

  /**
   * Reference to <outline-org-chart> in panels slot.
   */
  @queryAssignedElements({ slot: 'panels' })
  'panels': OutlineOrgChartBaselinePanel[];

  'render'(): TemplateResult {
    return html`
      <section class="org-chart">
        <div class="org-chart--top-content">
          <div class="org-chart--heading">
            ${this.slots.conditionalSlot('heading', false)}
          </div>
        </div>
        <div @keydown=${this.handleKeyboardNav}>
          <slot name="panels"></slot>
        </div>
      </section>
    `;
  }

  /**
   * @param event
   * @returns void
   * Adds up/down arrow keyboard navigation.
   * TODO: try to refactor to something simpler.
   */
  'handleKeyboardNav'(event: KeyboardEvent) {
    let index = 0;
    const panels = this.panels;
    const start = Array.prototype.indexOf.call(
      panels,
      event.target as HTMLElement
    );

    // bail on wrong key
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      return;
    }
    if (event.key === 'ArrowDown') {
      if (panels?.length && start + 1 > panels?.length - 1) {
        index = 0;
      } else index = start + 1;
    }
    if (event.key === 'ArrowUp') {
      if (panels?.length && start - 1 < 0) {
        index = panels?.length - 1;
      } else index = start - 1;
    }
    const focusTarget = panels?.[index] as unknown as HTMLElement;
    focusTarget.shadowRoot?.querySelector('button')?.focus();
  }
}
